import { render, staticRenderFns } from "./monthlyCarRenewalRecord.vue?vue&type=template&id=0a1c6f4b&scoped=true"
import script from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js"
export * from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js"
import style0 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=0&id=0a1c6f4b&prod&scoped=true&lang=css"
import style1 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=1&id=0a1c6f4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c6f4b",
  null
  
)

export default component.exports